export default {
    message: {
        message: "Bem vindo de volta, {name}",
        impersonation: "Você está fazendo um pedido em nome de «{name}»"
    }
}